import axios from 'axios';

export const sendOtp = (orderId, type, commissionPaidBy = null) => {
  return axios({
    url: `/api/orders/send-otp/${orderId}`,
    method: 'post',
    data: { type, commissionPaidBy },
  });
};

export const checkOtp = (orderId, otp, additionalOtps = {}) => {
  return axios({
    url: `/api/orders/check-otp/${orderId}`,
    method: 'post',
    data: {
      otp,
      additional_otps: additionalOtps,
    },
  });
};

export const checkOtpSubmitted = (orderId) => {
  return axios({
    url: `/api/orders/${orderId}/check-otp-submitted`,
    method: 'get',
  });
};
